export enum TextComponentNameLevel1 {
  ACCIDENT_COVERAGES = "accidentcoverage",
  ADDITIONAL_BUILDINGS = "additionalbuildings",
  ADVICE = "adviceform",
  AKA_CHILD = "akachild",
  AKA_FAMILY_ACCIDENT = "akafamilyaccident",
  AKA_HEALTH = "akahealth",
  AKA_HEALTH_COVERAGES = "akahealthcoverage",
  AKA_HOUSE_CONTENTS_COVERAGES = "akahousecontentscoverage",
  AKA_STUDENT = "akastudentform",
  AKA_STUDENT_COVERAGES = "akastudentcoverage",
  AKA_HOUSE_CONTENTS = "akahousecontentsform",
  AKA_TRAVEL = "akatravel",
  ANIMAL = "animal",
  ANIMAL_COVERAGES_NEW = "newanimalcoverage",
  CABIN = "cabinform",
  CABIN_COVERAGES = "cabincoverage",
  CABIN_CONTENTS = "cabincontentsform",
  CAR = "carform",
  CHILD_COVERAGES = "childcoverage",
  CHILD_HEALTH_COVERAGES = "childhealthcoverage",
  COVERAGE_CARD = "coveragecard",
  HEALTH = "healthform",
  HEALTH_COVERAGES = "healthcoverage",
  HOUSE = "houseform",
  HOUSE_CONTENTS = "housecontentsform",
  HOUSE_CONTENTS_CALCULATOR = "housecontentscalculator",
  HOUSE_CONTENTS_COVERAGES = "housecontentscoverage",
  HOUSE_COVERAGES = "housecoverage",
  HUSEIERNE_HOUSE_CONTENTS_COVERAGE = "huseiernehousecontentscoverage",
  HUSEIERNE_HOUSE_CONTENTS = "huseiernehousecontentsform",
  MOPED_COVERAGES = "mopedcoverage",
  PREGNANT_AND_NEWBORN_COVERAGES = "pregnantandnewborncoverage",
  PRODUCTS = "insuranceproduct",
  RECENT_DAMAGES = "recentdamages",
  RENTAL_COVERAGES = "rentalcoverage",
  SOP_SICKNESS_LEAVE = "sopsicknessleaveform",
  TRAVEL = "travelform",
  VALUABLES = "valuablesform",
  PARTNER_COOP = "partnercoop",
}

export enum TextComponentNameLevel2 {
  ALERT_DESCRIPTION = "alertdescription",
  ALERT_TITLE = "alerttitle",
  HINT = "hint",
  INGRESS = "ingress",
  LABEL = "label",
  OPTION_DISABLED = "optiondisabled",
  OPTION_HINT = "optionhint",
  OPTION_ID = "optionid",
  OPTION_INFO = "optioninfo",
  OPTION_LABEL = "optionlabel",
  OPTION_VALUE = "optionvalue",
  SHORT_TITLE = "shorttitle",
  SUBHEADERS = "subheaders",
  VALIDATION = "validation",
}

export enum Variants {
  BASE = "base",
  ENGLISH = "english",
  MARKDOWN = "markdown",
  NEW_TERMS_2025 = "new-coverages-2025",
}

export enum Tags {
  MARKDOWN = "MARKDOWN",
  CAPTION = "CAPTION",
  DESCRIPTION = "description",
}
